<template>
  <div>
    <vs-popup
        class="cancel-modal"
        :title="title"
        v-if="order !== null"
        :active.sync="showPopup"
    >
      <vs-input v-model="reason" class="spacing w-full mb-2" label="Reden (Verplicht)"></vs-input>
      <p v-if="order.payment_method === 'Contant'">Dit is een contante order, er zal geen terugstorting
        plaatsvinden.</p>
      <p v-else>Door deze bestelleing te annuleren, stort je € {{ order.price }},- terug op de rekening van de
        klant.</p>
      <br>
      <template>

        <vs-button class="mr-3 w-full mb-2 vs-con-loading__container" id="refund-button" ref="loadableButton"
                   :disabled="!allowRefund" @click="cancelOrder">Annuleren
        </vs-button>
      </template>
    </vs-popup>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showPopup: false,
      massActive: false,
      order: null,
      reason: ""
    };
  },
  computed: {
    title() {
      return "Bestelling #" + this.order.id + " annuleren";
    },

    allowRefund() {
      return this.reason.length > 4;
    },

    cancelButtonText() {
      let isCash = this.order.payment_method === 'Contant';
      return "Annuleren" + isCash ? "" : " en terugstorten";
    }
  },
  methods: {

    cancelOrder() {
      let data = {
        _method: 'POST',
        order_id: this.order.id,
        reason: this.reason
      };
      this.$http
          .post("https://api.staging.hebtrek.nl/staff/order/cancel", data, {
            headers: {
              Authorization:
                  "Bearer " + JSON.parse(localStorage.getItem("stafftoken")),
            },
          })
          .then(() => {
            this.showPopup = false;
            this.$util.notify('Gelukt', 'Order is geannuleerd', this.$vs);
          })
          .catch((error) => {
            this.$util.logError(error, this.$vs);
          });
    }
    },
    mounted() {
      this.isMounted = true;
      this.$events.listen("open-cancel-modal", (order) => {
        this.showPopup = true;
        this.order = order;
        console.log(order);
      });
    },
  };
</script>